module.exports = "/_next/static/images/red-waves-2e951b2d7ae902e1e593aee297b8d2e0.png";